export enum UiComponentsDataTestIdEnum {
  ACCORDION_SSR_ICON = 'accordion-ssr-icon',
  PILL_CONTAINER = 'pill-container',
  PILL_START_ICON = 'pill-start-icon',
  PILL_LABEL = 'pill-label',
  PILL_DESCRIPTION = 'pill-description',
  PILL_CLOSE = 'pill-close',
  DECORATIVE_PILL_CONTAINER = 'decorative-pill-container',
  DECORATIVE_PILL_START_ICON = 'decorative-pill-start-icon',
  DECORATIVE_PILL_LABEL = 'decorative-pill-label',
  DECORATIVE_PILL_DESCRIPTION = 'decorative-pill-description',
}
